import { lazy } from 'react';
import modules from '@src/service/modules';

const ChangePassword = lazy(() => import('../../views/UserProfile/ChangePassword'));
const UserProfile = lazy(() => import('../../views/UserProfile/Profile'));

const ProfileRoutes = [
    {
        path: '/profile/change-password',
        element: <ChangePassword />
    },
    {
        path: '/profile',
        element: <UserProfile />
    },
    {
        path: 'setup/user/profile/:id',
        element: <UserProfile />
    }
];

export default ProfileRoutes;
